import type React from 'react'

const FileIconBlank: React.FC = () => {
  return (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.125 0.625V4.875H13.375L9.125 0.625ZM8.0625 4.875V0.625H2.21875C1.32227 0.625 0.625 1.35547 0.625 2.21875V16.0312C0.625 16.9277 1.32227 17.625 2.21875 17.625H11.7812C12.6445 17.625 13.375 16.9277 13.375 16.0312V5.9375H9.125C8.52734 5.9375 8.0625 5.47266 8.0625 4.875Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default FileIconBlank
